// extracted by mini-css-extract-plugin
export default {"v-application":"Tabs_v-application_BzP96","text-h1":"Tabs_text-h1_HrRRb","text-h2":"Tabs_text-h2__DWSn","tabs":"Tabs_tabs_iu0KY","activeTab":"Tabs_activeTab_c5vrG"};